import React, { useMemo, useState } from 'react';
import mustache from 'mustache';
export const useConsentClientTool = _ref => {
  let {
    setLoadingsCount
  } = _ref;
  const consentHandler = React.useRef(_userConsent => {
    throw new Error('consentHandler is not initialized');
  });
  const [consentMessage, setConsentMessge] = useState();
  const consentMessageWidget = useMemo(() => {
    if (!consentMessage) {
      return undefined;
    }
    return {
      handler: consentMessage.resolve,
      role: 'consentController',
      content: `<<${JSON.stringify({
        widget: 'CONSENT_CONTROLLER',
        data: {
          text: consentMessage.message
        }
      })}>>`
    };
  }, [consentMessage]);
  return {
    consentTool: {
      consentWithMessage: {
        async execute(params, _temp) {
          let {
            message: messageTemplate,
            ...extraPayload
          } = _temp === void 0 ? {
            message: ''
          } : _temp;
          const message = mustache.render(messageTemplate ?? '', {
            input: params
          });
          const p = new Promise(resolve => {
            setLoadingsCount(prev => prev - 1);
            consentHandler.current = payload => {
              resolve({
                success: true,
                content: null,
                widgetResponse: JSON.stringify({
                  ...params,
                  ...extraPayload,
                  userConsent: payload
                })
              });
              setConsentMessge(undefined);
              setLoadingsCount(prev => prev + 1);
              // TODO - reset consentHandler.current
            };
          });
          setConsentMessge({
            resolve: consentHandler.current,
            message
          });
          return p;
        },
        // @ts-expect-error
        beforeExecute(params, request) {
          if (!request) {
            return;
          }
        }
      }
    },
    consentMessage: consentMessageWidget
  };
};
//# sourceMappingURL=useConsentClientTool.js.map